/*
 * @Description: 教务通知
 */
import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/pcHome.vue'
const educNotificationRouter: Array<RouteRecordRaw> = [
    {
        path: '/educNotification',
        component: Layout,
        redirect: '/educNotification/notification/notificationList',
        children: [
          {
            path: 'notification',
            component: () => import(/* webpackChunkName: "Notification" */ '@/views/educNotification/index.vue'),
            name: 'Notification',
            redirect: '/educNotification/notification/notificationList',
            meta: { title: '教务通知' },
            children:[
              {
                path: 'notificationList',
                component: () => import(/* webpackChunkName: "NotificationList" */ '@/views/educNotification/notificationList/index.vue'),
                name: 'NotificationList',
                meta: { title: '教务通知列表' },
              },
              {
                path: 'postMessage',
                component: () => import(/* webpackChunkName: "PostMessage" */ '@/views/educNotification/postMessage/index.vue'),
                name: 'PostMessage',
                meta: { title: '发送通知' }
              },
            ]
          },
         
        ]
      }
]

export default educNotificationRouter
